// import { useKeycloak } from "@react-keycloak/web";
// import { useNavigate } from "react-router-dom";
// import { useDispatch } from "react-redux";
// import { clearAllCache } from "../store/cacheSlice";
 

// export const useAuth = () => {
//   const { keycloak } = useKeycloak();

  
//    const dispatch = useDispatch();

//   const username = keycloak?.tokenParsed?.preferred_username || "";
//   const fullName = keycloak?.tokenParsed?.name || "";
//   const email = keycloak?.tokenParsed?.email || "";
//   const roles = keycloak?.tokenParsed?.realm_access?.roles || [];
//   const isAuthenticated = keycloak?.authenticated;

//   const hasRole = (role) => roles.includes(role);

//   const logout = () => {
//      dispatch(clearAllCache());
//     keycloak.logout({ redirectUri: window.location.origin + "/" });
//     localStorage.clear();
//   };

//   return {
//     keycloak,
//     isAuthenticated,
//     username,
//     fullName,
//     email,
//     roles,
//     hasRole,
//     logout,
//   };
// };

import { useSessionAuth } from "../auth/SessionAuthContext";

import { useDispatch } from "react-redux";
import { clearAllCache } from "../store/cacheSlice";

export const useAuth = () => {
  const { customToken, roles, isAuthenticated, logout } = useSessionAuth();
  const dispatch = useDispatch();

  const decoded = customToken ? JSON.parse(atob(customToken.split(".")[1])) : {};

  const username = decoded?.preferred_username || decoded?.email || "";
  const fullName = decoded?.name || "";
  const email = decoded?.email || "";
  const tokenRoles = roles || [];

  const hasRole = (role) => tokenRoles.includes?.(role) || false;

  const handleLogout = () => {
    dispatch(clearAllCache());
    logout(); // redirects to backend logout
    localStorage.clear();
  };

  return {
    isAuthenticated,
    username,
    fullName,
    email,
    roles: tokenRoles,
    hasRole,
    logout: handleLogout,
  };
};
